import { Navigate, Outlet } from 'react-router-dom';
import { PATHS } from '@/const';

interface IPrivateRoute {
    isAllowed: boolean;
    children?: React.ReactNode;
}

const UNAUTHORIZED_REDIRECT_PATH = PATHS.auth.login.callback;

const PrivateRoute = ({ isAllowed, children }: IPrivateRoute) => {
    if (!isAllowed) {
        return <Navigate replace to={UNAUTHORIZED_REDIRECT_PATH} />;
    }

    return <> {children ?? <Outlet />} </>;
};

export default PrivateRoute;
